(function($) {
    $('.home-slider').slick({
        infinite: true,
        arrows: true,
        dots: true,
        autoplay: true,
        autoplaySpeed: 2000
    });

    $('.product-slider, .related .products').slick({
        infinite: false,
        arrows: true,
        dots: true,
        slidesToShow: 4,
        slidesToScroll: 4,
        responsive: [
            {
                breakpoint: 813,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 2
                }
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    });

    $('.ideas-slider').slick({
        infinite: false,
        arrows: true,
        dots: true,
        slidesToShow: 3,
        slidesToScroll: 4,
        responsive: [
            {
                breakpoint: 812,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 2
                }
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    });

    $('.single-product-slider').slick({
        infinite: false,
        arrows: true,
        dots: true,
        slidesToShow: 1,
        slidesToScroll: 1
    });
})(jQuery);